// 夜をまたぐシフト（例：22:00〜翌02:00）の時間計算。
// シフトは開始日（営業日）に属し、時刻は開始日の0時からの分で表す（翌2:00 は 26:00＝1560分）。

const pad = (n: number) => String(n).padStart(2, '0');
const clockOf = (iso: string) => Number(iso.slice(11, 13)) * 60 + Number(iso.slice(14, 16));

/** 開始時刻（開始日の0時からの分） */
export const sMin = (sh: { start: string }) => clockOf(sh.start);

/** 終了時刻（開始日の0時からの分）。終了日が翌日、または終了時刻が開始時刻以前なら翌日として扱う */
export const eMin = (sh: { start: string; end: string }) => {
  const s = clockOf(sh.start); let e = clockOf(sh.end);
  const dayDiff = Math.round((Date.parse(sh.end.slice(0, 10)) - Date.parse(sh.start.slice(0, 10))) / 86400000);
  if (dayDiff > 0) e += dayDiff * 1440;
  else if (e <= s && sh.end.slice(11, 16) !== sh.start.slice(11, 16)) e += 1440;
  return e;
};

/** 日付文字列に日数を足す */
export const addDaysStr = (day: string, n: number) => {
  if (n === 0) return day;
  const d = new Date(`${day}T00:00:00Z`); d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

/** 営業日と分から日時文字列を作る（1440分以上は翌日） */
export const isoAt = (day: string, min: number) => `${addDaysStr(day, Math.floor(min / 1440))}T${pad(Math.floor((min % 1440) / 60))}:${pad(min % 60)}:00`;

/** 画面表示用の時刻（翌日は「翌」を付ける。例：翌02:00） */
export const clockLabel = (min: number) => `${min >= 1440 ? '翌' : ''}${pad(Math.floor((min % 1440) / 60))}:${pad(min % 60)}`;

/** シフトの時間帯の表示（例：22:00〜翌02:00） */
export const rangeLabel = (sh: { start: string; end: string }) => `${clockLabel(sMin(sh))}〜${clockLabel(eMin(sh))}`;

/** "HH:MM" の開始・終了から日時を作る（終了が開始以前なら翌日） */
export const isoRange = (day: string, startTime: string, endTime: string) => {
  const s = Number(startTime.slice(0, 2)) * 60 + Number(startTime.slice(3, 5));
  let e = Number(endTime.slice(0, 2)) * 60 + Number(endTime.slice(3, 5));
  if (e <= s) e += 1440;
  return { start: isoAt(day, s), end: isoAt(day, e) };
};

/** "18:00-01:00" のような時間帯の文字列を表示用にする（夜をまたぐ場合は「翌」を付ける。00:00-00:00 などはそのまま） */
export const timeTextLabel = (time?: string) => {
  if (!time) return '';
  const [a0, a1] = time.split('-');
  if (!a1) return time;
  return `${a0}〜${a1 < a0 ? '翌' : ''}${a1}`;
};
